module.exports = __webpack_public_path__ + "img/product.6f342e13.svg";